/** Main menu structure (labels are i18n keys under `nav.*`). */
export type NavItem = {
  key: 'home' | 'about' | 'services' | 'events' | 'contact';
  to?: string;
  /** Paths that make this top-level item "active". */
  match: string[];
  children?: {
    key: 'companyBackground' | 'ourClients' | 'ourStaff' | 'ourEvents' | 'otherEvents';
    to: string;
  }[];
};

export const NAV: NavItem[] = [
  { key: 'home', to: '/', match: ['/'] },
  {
    key: 'about',
    match: ['/company-background', '/our-clients', '/our-staff'],
    children: [
      { key: 'companyBackground', to: '/company-background' },
      { key: 'ourClients', to: '/our-clients' },
      { key: 'ourStaff', to: '/our-staff' },
    ],
  },
  { key: 'services', to: '/services', match: ['/services'] },
  {
    key: 'events',
    match: ['/events', '/other-events'],
    children: [
      { key: 'ourEvents', to: '/events' },
      { key: 'otherEvents', to: '/other-events' },
    ],
  },
  { key: 'contact', to: '/contact-us', match: ['/contact-us'] },
];
